import { TDetails } from "keen-slider";

export const shiftSlidesInCarousel = (
  details: TDetails,
  dir: 'left' | 'right',
  slides: number
): number => {
  return dir === 'left'
    ? Math.ceil(details.relativeSlide) - slides
    : Math.ceil(details.relativeSlide) + slides;
};
